import { Component, EventEmitter, Input, Output } from '@angular/core';
import { InspectionWaterFlowCase } from '@authority-labs/api-interfaces';

@Component({
  selector: 'authority-labs-check-water-flow-case',
  templateUrl: './check-water-flow-case.component.html',
  styleUrls: ['./check-water-flow-case.component.scss']
})
export class CheckWaterFlowCaseComponent {
  @Input() waterFlowData: InspectionWaterFlowCase;
  @Input() readonly: boolean;
  @Input() printPreview: boolean;
  @Output() dataChange: EventEmitter<void> = new EventEmitter();

  onChange(): void {
    this.dataChange.emit();
  }
}
